// extracted by mini-css-extract-plugin
export default {"content":"ProductiveProcessManage_content__L+ZfN","tabStyles":"ProductiveProcessManage_tabStyles__5FLiA"};